// const { $ } = window
// const $body = $(document.body)

export default {
  init() {
    let tosNav = document.querySelector(".tos-nav ul");
    let sections = document.querySelectorAll(".tos-content h2");
    let active = document.querySelector(".tos-nav-active");
    let activeSpan = active.querySelector("span");

    activeSpan.innerText = sections[0].innerText;

    //dyanmically create anchors
    for (let section of sections) {
      let a = document.createElement("a");
      let li = document.createElement("li");
      a.innerText = section.innerText;
      section.id = section.innerText
        .toLowerCase()
        .replace(/&/, "")
        .replace(/\s+/gi, "-");
      a.href = `#${section.id}`;
      a.setAttribute("data-id", section.id);
      li.append(a);
      tosNav.append(li);
    }

    //click handler
    $(".tos-nav a").on("click", (e) => {
      if (e.target.tagName.toLowerCase() != "a") {
        console.log("not A");
        return;
      }
      let a = e.target;
      activeSpan.innerText = a.innerText;
      $(".tos-nav a").removeClass("active");
      setTimeout(() => {
        a.classList.add("active");
      }, 200);
    });

    let animating = false; //onScrollDisabled = true
    function animationThrottle() {
      // if (animating) {
      //   return;
      // }
      animating = true;
      console.log(animating)
      setTimeout(() => {
        animating = false;
        console.log(animating)
      }, 850);
    }

    let url = new URL(window.location.href);
    //check url on page load to navigate to respective section
    if (url.hash) {
      animationThrottle()
      let a = document.querySelector(`[data-id=${url.hash.replace("#", "")}]`);
      a.classList.add("active");
      activeSpan.innerText = document.querySelector(url.hash).innerText;
    }

    function toggleTOSNav() {
      if (animating) {
        return;
      }
      animationThrottle();
      $(tosNav).toggleClass("is-open");
      $(tosNav).slideToggle();
    }

    function closeTOSNav() {
      if (animating) {
        return;
      }
      animationThrottle();
      $(tosNav).removeClass("is-open");
      $(tosNav).slideUp();
    }

    function handleMobileDropdown(x) {
      if (x.matches) {
         console.log('enabled')
         $(tosNav).hide();
         $(tosNav).find("li").off("click", animationThrottle);
         $(tosNav).find("li").on("click", closeTOSNav);
      } else {
         console.log('disabled')
        $(tosNav).show();
        $(tosNav).find("li").off("click", closeTOSNav);
        $(tosNav).find("li").on("click", animationThrottle);
      }
    }

    //toggle mobile dropdown functionality
    var x = window.matchMedia("(max-width: 768px)");
    handleMobileDropdown(x); // Call listener function at run time
    x.addListener(handleMobileDropdown); // Attach listener function on state changes

    //mobile dropdown functionality - click handler
    active.addEventListener("click", toggleTOSNav);

    let sections_arr = Array.from(sections);
    let activeID = "";
    let windowHeight = window.innerHeight;
    function checkActive() {
      //prevent when page scrolling due to click of nav anchor
      if (animating) {
        return;
      }

      let el,
        els = sections_arr.filter(
          (el) => el.getBoundingClientRect().top > windowHeight / 10
        );
      if (!els.length) {
        els = sections_arr.slice(-1);
      }
      el = els[0];
      if (activeID.includes(el.id)) {
        return;
      }
      let activeA = document.querySelector(`a[data-id=${el.id}]`);
      activeSpan.innerText = activeA.innerText;
      $(".tos-nav a").removeClass("active");
      activeA.classList.add("active");
      //terms.js:128 Throttling navigation to prevent the browser from hanging. 
      //See https://crbug.com/1038223. Command line switch 
      //--disable-ipc-flooding-protection can be used to bypass the protection
      history.replaceState({}, '', window.location.origin + window.location.pathname + '#' + el.id)
    }
    window.addEventListener("scroll", function () {
      checkActive();
    });
    window.onresize = () => {
      let windowHeight = window.innerHeight;
    };

    //copy to clipbaord - h2
    sections_arr.map(el => {
      el.addEventListener('click', () => {
         let url = window.location.origin + window.location.pathname + '#' + el.id
         navigator.clipboard.writeText(url);
         el.classList.add('clicked')
         setTimeout(() => { el.classList.remove('clicked')}, 2000)
      })
    })
  },
  finalize() {},
};
